import './urlsearchparams';

export const getURLSearchParams = (search) => {
  if (search.includes('liff.state')) {
    const s = new URLSearchParams(decodeURIComponent(search.split('%3F')[1]));
    return s;
  }
  const s = new URLSearchParams(decodeURIComponent(search));
  return s;
};

export const getSearchParamsStrings = () => {
  if (typeof window !== `undefined`) {
    const searchParams = new URLSearchParams(window.location.search).toString();
    return searchParams ? `?${searchParams}` : '';
  }
};

export const getURLSearchParamByKey = (key) => {
  if (typeof window !== `undefined`) {
    const a = getURLSearchParams(window.location.search);
    return a.get(key);
  }
};

export const getOption = () => {
  if (typeof window !== `undefined`) {
    const a = getURLSearchParams(window.location.search);
    return a.get('option');
  }
  return '';
};

// constants: BOOKING_TYPE
export const getBookingType = () => {
  if (typeof window !== `undefined`) {
    const a = getURLSearchParams(window.location.search);
    return a.get('bookingType');
  }
  return '';
};

export const getDataSource = () => {
  if (typeof window !== `undefined`) {
    const a = getURLSearchParams(window.location.search);
    return a.get('datasource');
  }
  return '';
};

export const getProgress = () => {
  if (typeof window !== `undefined`) {
    const a = getURLSearchParams(window.location.search);
    return a.get('progress') === 'true';
  }
  return false;
};

export const getLiffId = () => {
  const a = getURLSearchParams(window.location.search);
  return a.get('liffId');
};

export const getRequestedService = () => {
  if (typeof window === `undefined`) {
    return '';
  }
  const a = getURLSearchParams(window.location.search);
  return a.get('service') || '';
};

export const getUserID = () => {
  const a = getURLSearchParams(window.location.search);
  return a.get('lineID') || a.get('id');
};

export const queryStringAction = () => {
  const a = getURLSearchParams(window.location.search);
  return a.get('action') || '';
};

export const queryStringExternal = () => {
  const a = getURLSearchParams(window.location.search);
  return a.get('external') || '';
};

export const getSuccessOpenPageUrl = () => {
  const urlObj = new URL(window.location.href);
  const params = new URLSearchParams(urlObj.search);
  const extracted = params.get('openPageAfterSuccess');
  if (extracted) {
    return decodeURIComponent(extracted);
  } else {
    return null;
  }
};

const isProductionBuild = () => !window.location.host.includes('-staging');

export const getApStage = () =>
  isProductionBuild() ? 'production' : 'staging';

// 該用戶尚未建檔或取號流程出錯時，導回 /users/self 補建資料，帶 goBack=true 讓對方填完後導回原頁
export const redirectToUsersSelf = (replaceLink) => {
  const currentUrl = window.location.href;
  const goBack = `${window.location.search ? '&' : '?'}goBack=true`;
  window.location.replace(
    currentUrl.replace(replaceLink, '/users/self') + goBack
  );
};

export const getChannelUrl = (lineID) => {
  if (lineID !== '') {
    const url = `https://line.me/R/ti/p/${lineID}`;
    return encodeURI(url);
  }
  return isProductionBuild()
    ? 'https://line.me/R/ti/p/%40588ykjlq'
    : 'https://line.me/R/ti/p/%40dla7135r';
};
